// extracted by mini-css-extract-plugin
module.exports = {"navbar":"estilos_navbar__1ViXa","link":"estilos_link__3JGz9"};